import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = { notify_match_enabled: true, notify_gallery_enabled: true, messaging_enabled: true, stories_page_enabled: true, has_custom_logo: false };

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refreshSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      setSettings(DEFAULTS);
    }
  }, []);

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  return <SettingsContext.Provider value={{ settings, refreshSettings }}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
